import { useJsApiLoader } from '@react-google-maps/api'

// Single shared loader for every map on the site. <LoadScript> is not used
// anywhere because its unmount cleanup removes the Maps <script> plus any
// <style> tag containing ".gm-" — in dev that style tag is the whole App.css
// bundle, which broke the page layout after client-side navigation.
// useJsApiLoader loads the script once and leaves it alone on unmount.
// All callers must share the same id/key/libraries, so keep them here.
const GOOGLE_MAPS_LIBRARIES = ['geometry', 'drawing']

export const useGoogleMaps = () =>
    useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyAOvlaMKD4C0dPSjCtNOi-DnwkW8s4pSbI',
        libraries: GOOGLE_MAPS_LIBRARIES,
    })
